import { toast } from 'react-toast-notification'

const success = (message) => {
    if (message) {
        toast(message, {
            status: 'Successful',
            type: 'success',
            autoHide: true,
            delay: '5000',
        })
    }
}

const error = (message) => {
    if (message) {
        toast(message, {
            status: 'Error',
            type: 'error',
            autoHide: true,
            delay: '5000',
        })
    }
}
const warning = (message) => {
    if (message) {
        toast(message, {
            status: 'Warning',
            type: 'warn',
            autoHide: true,
            delay: '5000',
        })
    }
}


// eslint-disable-next-line import/no-anonymous-default-export
export default { success, error, warning }
